import { REHYDRATE } from 'redux-persist';
import update from 'immutability-helper';
import _ from 'lodash';
import {
  PRODUCT_MANAGER_INIT,
  PRODUCT_MANAGER_GET_PRODUCT_PROFILE_BEGIN,
  PRODUCT_MANAGER_GET_PRODUCT_PROFILE_SUCCESS,
  PRODUCT_MANAGER_GET_PRODUCT_PROFILE_FAIL,
  PRODUCT_MANAGER_PUT_PRODUCT_BEGIN,
  PRODUCT_MANAGER_PUT_PRODUCT_SUCCESS,
  PRODUCT_MANAGER_PUT_PRODUCT_FAIL,
  PRODUCT_MANAGER_POST_FOLDER_BEGIN,
  PRODUCT_MANAGER_POST_FOLDER_SUCCESS,
  PRODUCT_MANAGER_POST_FOLDER_FAIL,
  PRODUCT_MANAGER_UPDATE_FILES_BEGIN,
  PRODUCT_MANAGER_UPDATE_FILES_SUCCESS,
  PRODUCT_MANAGER_UPDATE_FILES_FAIL,
  PRODUCT_MANAGER_CREATE_FILES_BEGIN,
  PRODUCT_MANAGER_CREATE_FILES_SUCCESS,
  PRODUCT_MANAGER_CREATE_FILES_FAIL,
  PRODUCT_MANAGER_GET_REMINDER_BEGIN,
  PRODUCT_MANAGER_GET_REMINDER_SUCCESS,
  PRODUCT_MANAGER_GET_REMINDER_FAIL,
  PRODUCT_MANAGER_UPDATE_REMINDER_BEGIN,
  PRODUCT_MANAGER_UPDATE_REMINDER_SUCCESS,
  PRODUCT_MANAGER_UPDATE_REMINDER_FAIL,
  PRODUCT_MANAGER_DELETE_REMINDER_BEGIN,
  PRODUCT_MANAGER_DELETE_REMINDER_SUCCESS,
  PRODUCT_MANAGER_DELETE_REMINDER_FAIL,
  PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_BEGIN,
  PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_SUCCESS,
  PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_FAIL,
} from '../../actions/productManagerAction';

const INITIAL_STATE = {
  data: {
    name: '',
    itemNo: '',
    additionalItemNo: '',
    productCategories: [{}],
    suppliers: [{}],
    factories: [{}],
    buyers: [{}],
    documents: {
      inspection: {},
      testing: {},
      design: {},
      materials: {},
      shipping: {},
      manufacturing: {},
    },
    reminder: [{}],
  },
  status: 'uninitialized',
};

export default function productManagerListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case PRODUCT_MANAGER_INIT:
      return { ...INITIAL_STATE, status: 'editing' };

    // Product Profile Info

    case PRODUCT_MANAGER_GET_PRODUCT_PROFILE_BEGIN:
      return { ...state, status: 'fetching' };

    case PRODUCT_MANAGER_GET_PRODUCT_PROFILE_SUCCESS:
      return update(state, {
        data: { $merge: action.data },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_GET_PRODUCT_PROFILE_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    case PRODUCT_MANAGER_PUT_PRODUCT_BEGIN:
      return { ...state, status: 'submitting' };

    case PRODUCT_MANAGER_PUT_PRODUCT_SUCCESS:
      return update(state, {
        data: { $set: action.data },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_PUT_PRODUCT_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    // Product Profile Files & Folder

    case PRODUCT_MANAGER_POST_FOLDER_BEGIN:
      return { ...state, status: 'submitting' };

    case PRODUCT_MANAGER_POST_FOLDER_SUCCESS:
      return update(state, {
        data: {
          files: {
            [action.data.type]: {
              fileArr: { $push: [action.data] },
            },
          },
        },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_POST_FOLDER_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case PRODUCT_MANAGER_CREATE_FILES_BEGIN:
      return { ...state, status: 'submitting' };

    case PRODUCT_MANAGER_CREATE_FILES_SUCCESS:
      const fileArr = state.data.files[Object.keys(action.data)].fileArr.concat(
        action.data[Object.keys(action.data)]
      );

      return update(state, {
        data: { files: { [Object.keys(action.data)]: { fileArr: { $set: fileArr } } } },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_CREATE_FILES_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case PRODUCT_MANAGER_UPDATE_FILES_BEGIN:
      return { ...state, status: 'submitting' };

    case PRODUCT_MANAGER_UPDATE_FILES_SUCCESS:
      const { id, key, data } = action.data;
      const files = state.data.files[data.type].fileArr;
      const idx = _.findIndex(files, { id });

      return update(state, {
        data: {
          files: { [data.type]: { fileArr: { [idx]: { [key]: { $set: data[key] } } } } },
        },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_UPDATE_FILES_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    // Product Profile Reminder

    case PRODUCT_MANAGER_GET_REMINDER_BEGIN:
      return { ...state, status: 'fetching' };

    case PRODUCT_MANAGER_GET_REMINDER_SUCCESS:
      return update(state, {
        data: {
          reminder: { $set: action.data.reminder },
        },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_GET_REMINDER_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    case PRODUCT_MANAGER_UPDATE_REMINDER_BEGIN:
      return { ...state, status: 'fetching' };

    case PRODUCT_MANAGER_UPDATE_REMINDER_SUCCESS:
      return update(state, {
        data: {
          reminder: { $set: action.data.reminder },
        },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_UPDATE_REMINDER_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    case PRODUCT_MANAGER_DELETE_REMINDER_BEGIN:
      return { ...state, status: 'fetching' };

    case PRODUCT_MANAGER_DELETE_REMINDER_SUCCESS:
      return update(state, {
        data: {
          reminder: { $set: action.data.reminder },
        },
        status: { $set: 'success' },
      });

    case PRODUCT_MANAGER_DELETE_REMINDER_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    case PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_BEGIN:
      return { ...state, status: 'sending' };

    case PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_SUCCESS:
      return update(state, {
        status: { $set: 'sent' },
      });

    case PRODUCT_MANAGER_SEND_SHARE_FILES_EMAIL_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    default:
      return state;
  }
}
